module.exports = __webpack_public_path__ + "img/CL_round.738d877b.png";